export default class Modals {
  constructor() {
    this.triggers = document.querySelectorAll('[data-modal]')
    this.activeModals = []
    this.iframes = new Map()

    if (!this.triggers) return

    this.initHandlers()
    this.initTriggers()
  }

  hasBlockingModal() {
    return this.activeModals.some(
      (modal) => !modal.hasAttribute('data-non-blocking'),
    )
  }

  initHandlers() {
    const close = (e) => {
      const valid =
        e.key == 'Escape' ||
        e.target.closest('.is-exit') ||
        e.target.classList.contains('modal-background')

      if (valid && this.activeModals.length > 0) {
        // Get the topmost (most recently opened) modal
        const currentModal = this.activeModals[this.activeModals.length - 1]

        // Persistent modals (e.g. cookie consent while no choice has been made)
        // require an explicit action: Esc and backdrop clicks are ignored, only
        // an .is-exit control can close them.
        if (
          currentModal.hasAttribute('data-persistent') &&
          !e.target.closest('.is-exit')
        ) {
          return
        }

        // Remove the modal from active state
        currentModal.classList.remove('is-active')
        currentModal.removeEventListener('click', this.closeHandler)

        // Remove from active modals array
        this.activeModals.pop()

        // Handle iframe cleanup
        const iframe = this.iframes.get(currentModal)
        if (iframe) {
          iframe.src = ''
          this.iframes.delete(currentModal)
        }

        document.documentElement.classList.toggle(
          'is-clipped',
          this.hasBlockingModal(),
        )

        if (this.activeModals.length === 0)
          document.removeEventListener('keyup', this.closeHandler)
      }
    }

    this.closeHandler = close.bind(this)
  }

  /**
   * Open a modal element. Exposed so modals that aren't triggered by a click
   * (e.g. the cookie consent modal on page load) can be opened from JS.
   */
  open(modal) {
    if (!modal || this.activeModals.includes(modal)) return

    // Add to active modals stack
    this.activeModals.push(modal)

    // Add keyup listener once while there is at least one active modal.
    if (this.activeModals.length === 1) {
      document.addEventListener('keyup', this.closeHandler)
    }

    document.documentElement.classList.toggle(
      'is-clipped',
      this.hasBlockingModal(),
    )

    modal.classList.add('is-active')
    modal.addEventListener('click', this.closeHandler)

    // Skip hidden inputs (e.g. checkboxes inside a collapsed section) so
    // opening a modal never scrolls to something the user can't see.
    const inputElement = modal.querySelector('input')
    if (inputElement && inputElement.offsetParent !== null) inputElement.focus()

    const iframe = modal.querySelector('iframe')
    if (iframe) {
      iframe.src = iframe.dataset.src
      this.iframes.set(modal, iframe)
    }
  }

  openById(id) {
    this.open(document.querySelector(`.modal[data-id="${id}"]`))
  }

  initTriggers() {
    this.triggers.forEach((e) => {
      e.addEventListener('click', () => {
        this.open(
          document.querySelector('.modal[data-id=' + e.dataset.modal + ']'),
        )
      })
    })
  }
}
